import React from 'react'

import BaseModal from '../../../../molecules/ChatModals/BaseModal2'
import Button from '../../../../atoms/Button2'
import VerticalToggle from '../../../../atoms/VerticalToggle'

import { useBreakpoint } from '../../../../../providers/BreakpointProvider'
import { useQueueState } from '../../../../../providers/QueueStateProvider'
import { requestTranscript } from '../../../../../lib/api'
import { downloadBlob } from '../../../../../utilities'
import { useAppDispatch } from '../../../../../hooks/redux'
import { AddErrorAlert } from '../../../../../slices/alert'

import useStyles from './styles'

const CONV = 'Download conversation'
const ALL = 'Download entire timeline'

const OPTIONS = [CONV, ALL]

interface ConversationDownloadModalProps {
  open: boolean
  onClose: () => void
}
const ConversationDownloadModal: React.FC<ConversationDownloadModalProps> = ({
  open,
  onClose
}) => {
  const dispatch = useAppDispatch()
  const { isSmall, isMedium } = useBreakpoint()
  const { conversation } = useQueueState()

  const [selected, setSelected] = React.useState(CONV)
  const [downloading, setDownloading] = React.useState(false)
  const classes = useStyles()

  const handleClick = React.useCallback(() => {
    setDownloading(true)

    const gettingUser = selected === ALL
    const id = gettingUser ? conversation.owner_id : conversation.session

    requestTranscript(id, {}, gettingUser)
      .then(blob => {
        downloadBlob(gettingUser ? 'timeline.txt' : 'conversation.txt', blob)
        setDownloading(false)
        onClose()
      })
      .catch(err => {
        dispatch(AddErrorAlert({ err }))
      })
  }, [conversation.session, conversation.owner_id, selected, onClose, dispatch])

  return (
    <React.Fragment>
      <BaseModal
        open
        title='Download Conversation'
        showTitleOnMobile
        onClose={onClose}
        PaperProps2={{
          style: {
            padding: '20px 16px 24px 16px',
            border: '1px solid #C6C6C6',
            borderRadius: '4px',
            width: isMedium ? 'calc(100% - 4rem)' : '100%',
            maxWidth: isMedium ? 'unset' : '360px',
            height: isSmall && 'auto',
            maxHeight: isSmall && 'unset',
            minHeight: isSmall && 'auto'
          }
        }}
        classes={{ title: classes.modalTitle, close: classes.modalClose }}
      >
        <div className={classes.root}>
          <VerticalToggle
            name='download'
            options={OPTIONS}
            selected={selected}
            onChange={setSelected}
            className={classes.root}
          />
        </div>
        <Button
          disabled={downloading}
          onClick={handleClick}
          className={classes.button}
        >
          Download
        </Button>
      </BaseModal>
    </React.Fragment>
  )
}

export default ConversationDownloadModal
